import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import Geocode from 'react-geocode'
import {
  getRegions,
  saveNewRegion,
  deleteRegion,
  updateRegion,
  getCompanyFeatures,
} from '../../../actions/company'

import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import RegionsContainer from '../../../components/Regions/RegionsContainer'
import RegionsDispatchContainer from '../../../components/Regions/RegionsDispatchContainer'
import { openSuccessMessage, openErrorMessage } from '../../../actions/message'
import { isValidString } from '../../../utils/string'
import ModalDialog from '../../../components/common/ModalDialog'
import { monolithIsFeatureFlagEnable } from '../../../api/unleash'

import { UnleashToggles } from '../../../types/unleashToggles'

class Regions extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      listregion: [],
      regionConsumerTypeFlag: false,
    }
  }

  componentDidMount() {
    Geocode.setApiKey('AIzaSyBe4ZKdGYJv3zwOaMpyseVAURvHk19WFb4')
    this.props.dispatch(getRegions())
    this.props.dispatch(getCompanyFeatures())
    this.onDefaultRegion()
    this.checkRegionConsumerFlag()
  }

  validateRegion = (region) => {
    if (!isValidString(region.name)) {
      this.props.dispatch(openErrorMessage('Please enter the name of the region'))
      return false
    }

    if (!isValidString(region.zoneType)) {
      this.props.dispatch(openErrorMessage('Please enter the Zone Type of the region'))
      return false
    }

    /* if(!region.zipCodes || !region.zipCodes.length) {
            this.props.dispatch(openErrorMessage('Please enter the zipcodes for the region'));
            return false;
        } */

    if (region.zoneType === 'zipCode') {
      if (region.zipCodes.length == 0) {
        this.props.dispatch(openErrorMessage('Please enter one Zip Code'))
        return false
      }

      let validation = this.checkAllDuplicateZipCodes(region)
      if (validation.isDuplicated) {
        this.props.dispatch(
          openErrorMessage(`Zipcode ${validation.zipCode} already exists in other region`),
        )
        return false
      }
    }

    if (region.zoneType === 'kml') {
      let kmlActived = region.kmlEdges && region.kmlEdges.find((kml) => kml.active)

      if (!kmlActived) {
        this.props.dispatch(openErrorMessage('Please enter one KML'))
        return false
      }
    }

    return true
  }

  onSave = (region, afterSave) => {
    return new Promise((resolve, reject) => {
      let actionToHit = null

      if (this.validateRegion(region)) {
        if (region.id) {
          actionToHit = updateRegion
        } else {
          actionToHit = saveNewRegion
        }

        this.props
          .dispatch(actionToHit(region))
          .then((res) => {
            resolve(res)
            afterSave && afterSave()
            this.props.dispatch(openSuccessMessage('Region saved successfully'))
            this.props.dispatch(getRegions())
          })
          .catch((err) => {
            reject(err)
          })
      } else {
        reject(false)
      }
    })
  }

  onDelete = (region) => {
    this.props.dispatch(deleteRegion(region.id)).then((res) => {
      this.props.dispatch(openSuccessMessage('Region deleted successfully'))
      this.props.dispatch(getRegions())
    })
  }

  // **
  //add modal default region
  onDefaultRegion = () => {
    this.props.dispatch(getRegions()).then((res) => {
      //console.log(res.values)
      this.travelRegionValues(res.values)
    })
  }

  travelRegionValues = (res) => {
    const { companyFeatures = {} } = this.props.companyReducer
    const { availableApps = [] } = companyFeatures

    const regionDefaultState =
      res &&
      res.map((item) => {
        const result = true
        if (item.regionDefault) {
          return result
        }
      })
    const finalregion =
      (regionDefaultState && regionDefaultState.length > 0 && regionDefaultState.includes(true)) ||
      []
    if (finalregion == true) {
      console.log('there is a default region in true')
    } else {
      if (availableApps.length > 0 && availableApps && availableApps.indexOf('Dispatch') >= 0) {
        this.modalRegionDefault.handleClickOpen()
      }
    }
  }

  //this will check in all regions
  checkAllDuplicateZipCodes = (currentRegion) => {
    const { regions = {} } = this.props.companyReducer
    const { values = [] } = regions
    let zipCodes = currentRegion.zipCodes || []
    let zipCodeNoSpaces

    //getting all zipCodes of each region
    let zipCodesOfRegions = []
    for (let region of values) {
      //check all regions except current one
      if (currentRegion.id !== region.id && region.zipCodes && region.zipCodes.length > 0) {
        zipCodesOfRegions = [...zipCodesOfRegions, region.zipCodes]
      }
    }

    let result = false
    let value = null
    for (let zipCodesOfRegion of zipCodesOfRegions) {
      for (let zipCode of zipCodes) {
        zipCodeNoSpaces = zipCode.replace(/ /g, '')
        if (zipCodesOfRegion.includes(zipCodeNoSpaces)) {
          result = true
          value = zipCode
          break
        }
      }

      if (result) {
        break
      }
    }

    return { isDuplicated: result, zipCode: value }
  }

  checkRegionConsumerFlag = () => {
    monolithIsFeatureFlagEnable(UnleashToggles.REGION_CONSUMER_TYPE).then((res) =>
      this.setState({ regionConsumerTypeFlag: res }),
    )
  }

  render() {
    const { regions = {}, lastModified, companyFeatures = {} } = this.props.companyReducer
    const regionValues = (regions && regions.values) || []
    const { availableApps = [] } = companyFeatures
    const { onChange } = this.props
    const messageDefaultRegion =
      "There's no default region for this company. If you don't set one, auto assign proccess won't be available."
    const { regionConsumerTypeFlag = false } = this.state

    return (
      <div>
        {availableApps.length > 0 && availableApps && availableApps.indexOf('Dispatch') >= 0 ? (
          <RegionsDispatchContainer
            {...this.props}
            regions={regionValues || []}
            lastModified={lastModified}
            Geocode={Geocode}
            onDelete={this.onDelete}
            onSave={this.onSave.bind(this)}
            companyFeatures={companyFeatures}
            dispatch={true}
          />
        ) : (
          <RegionsContainer
            regions={regionValues || []}
            lastModified={lastModified}
            Geocode={Geocode}
            onDelete={this.onDelete}
            onSave={this.onSave.bind(this)}
            companyFeatures={companyFeatures}
            regionConsumerTypeFlag={regionConsumerTypeFlag}
          />
        )}
        {availableApps.length > 0 && availableApps && availableApps.indexOf('Dispatch') >= 0 && (
          <ModalDialog
            title={messageDefaultRegion}
            ref={(c) => (this.modalRegionDefault = c)}
            cancelText="ok"
            confirmText={false}
          ></ModalDialog>
        )}
      </div>
    )
  }
}

export default connect(({ dispatch, shopReducer, companyReducer, authReducer }) => ({
  dispatch,
  shopReducer,
  companyReducer,
  authReducer,
}))(ContainerWithTitle(Regions, 'Regions'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/Regions.js